// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kwq1","content":"styles_content__1kiYj","row":"styles_row__3hAyx","footer":"styles_footer__2JAAZ","phraseLength":"styles_phraseLength__1Gidd"};